/**
 通过Event Bus实现多向多层/持久化的数据存储和传递
**/
class Store {
  constructor(key) {
    this.key = key;
    // 项目启动时候到localstorage里拿
    this.data = this.get();
  }

  get(key) {
    const data = JSON.parse(localStorage.getItem(this.key)) || {};

    if (key) {
      return data[ key ];  
    }

    return data;
  }

  add(key, val) {
    // 如果是改变整个data
    if (typeof key !== 'string') {
      this.data = key;  
    // 反之只是改变this.data.key
    } else {
      if (key in this.data) {
        this.data[ key ] = val;
      }
    }

    localStorage.setItem(this.key, JSON.stringify(this.data));
  }

  delete(key) {
    if (!key) {
      this.clear();
    } else {
      delete this.data[ key ];
      localStorage.setItem(this.key, JSON.stringify(this.data));
    }
  }

  /*
    清空，当前时间大于过期时间，那么就过期了，需要清空
  */
  clear() {
    this.data = {};
    localStorage.setItem(this.key, JSON.stringify({}));
  }
}

export default new Store('globalStore');